import React from 'react';
import Fade from 'react-reveal/Fade';


const Description = () => {
  return (
	    <Fade>
	    	<div className="center_wrapper">
	    		<h2>Description</h2>
	    		<div className="highlight_description">
					The is a One Pager template, custome built with REACT, REACT-SLICK, REACT REVEAL, and MATERIALIZE for personal practice. It can be use for Infosites, Simple Portfolios. 
	    		</div>
	    	</div>
	    </Fade>
  )
}

export default Description;